import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Company } from "../../models/Company";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faSave } from "@fortawesome/free-solid-svg-icons";

type Props = {
  show: boolean;
  onHide: () => void;
  onSave: (company: Company) => void;
  company?: Company | null;
};

export const ModalCompanyForm: React.FC<Props> = ({
  show,
  onHide,
  onSave,
  company,
}) => {
  const [name, setName] = useState("");

  useEffect(() => {
    setName(company?.name || "");
  }, [show, company]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim() === "") return;
    onSave({ id: company?.id ?? 0, name });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>{company ? "Editar" : "Agregar"} compañía</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            <FontAwesomeIcon
              icon={faBan}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Cancelar</span>
          </Button>
          <Button variant="primary" type="submit">
            <FontAwesomeIcon
              icon={faSave}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Guardar</span>
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
